import { createContext } from 'react';

const UserContext = createContext({
  username: null,
  user: null,
  roleIds: [],
  setUserData: () => {},
  hasAnyRole: () => {},
  hasPermission: () => {}
});
UserContext.displayName = 'UserContext';

export default UserContext